/**
 * Sums two or more numbers
 *
 * ```hbs
 * {{add a b}}
 * ```
 *
 * @function add
 * @param {number[]} numbers A list of numbers to sum
 * @return {number} The sum of all the passed numbers
 */
export function add(posA: number, posB: number) {
  return Number(posA) + Number(posB);
}

/**
 * Divides two or more numbers
 *
 * ```hbs
 * {{div a b}}
 * ```
 *
 * @function divide
 * @param {number[]} numbers A list of numbers to divide
 * @return {number} The result of dividing all the passed numbers
 */
export function divide(posA: number, posB: number) {
  return Number(posA) / Number(posB);
}

/**
 * Subtracts two or more numbers
 *
 * ```hbs
 * {{sub a b}}
 * ```
 *
 * @function subtract
 * @param {number[]} numbers A list of numbers to subtract
 * @return {number} The difference of all the passed numbers
 */
export function subtract(posA: number, posB: number) {
  return Number(posA) - Number(posB);
}
